import { Route } from '@angular/router';


import {
  AvailabilityEffects,
  DestinationEffects,
  DestinationPersistanceEffects,
  OrderEffects,
  OrderTransactionEffects,
  OrderTimeoutEffects,
  OwnerEffects,
  ProductEffects,
  LayoutEffects,
  MappedAreaEffects,
  SessionStorageEffects,
} from '../app/core/effects';
import { provideEffects } from '@ngrx/effects';

export const APP_ROUTES = [
  /**
   * Preserve current routes by loading 'shop' module
   * by default, when navigates to either '' or '/'
   */
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'widget'
  },
  {
    path: 'widget',
    providers: [
      provideEffects([
        AvailabilityEffects,
        DestinationEffects,
        DestinationPersistanceEffects,
        OrderEffects,
        OrderTransactionEffects,
        OrderTimeoutEffects,
        OwnerEffects,
        ProductEffects,
        LayoutEffects,
        MappedAreaEffects,
        SessionStorageEffects,
      ]),
    ],
    loadChildren: () => import('./widget/routes'),
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: 'widget',
  },
] as Route[];
